import React from 'react';
import { useTable, usePagination } from 'react-table';
import styled from 'styled-components';
import { Text } from '../';

const TableWrapper = styled.div`
  width: 100%;
  background-color: yellow;
  overflow-x: scroll;
  padding-bottom: 12px;

  table {
    border-collapse: collapse;
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: scroll;

    thead {
      tr {
        border-radius: 15px;
        overflow: hidden;
        th {
          background-color: #eee;
          padding: 1rem;
          border: 1px solid red;
        }
      }
    }

    tbody {
      tr {
        td {
          width: 100px;
          border: 1px solid green;
          padding: 1rem;
        }
      }
    }
  }
`;

const Table = ({ data, columns }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,

    // Pagination stuff
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable({ data, columns }, usePagination);

  console.log({ data, columns });

  return (
    <TableWrapper className="shadow-md">
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  <div className="t-head">{column.render('Header')}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </TableWrapper>
  );
};

export default Table;
